export enum DashboardWidgetHeaderColor {
  Gray39 = 'gray-39',
  Gray49 = 'gray-49',
  Gray89 = 'gray-89',
  Gray92 = 'gray-92',
  Gray94 = 'gray-94',
  Error = 'error',
  Warning = 'warning',
}
